import React, { Component } from "react";
import { SpaceBetween, Box } from "@amzn/awsui-components-react/polaris";
import IspDashboardV2 from "./IspDashboardV2";
import ConstantLightHouse from "../utils/Constants";

export default class MultiIspDashboard extends Component {
    state = {
        cutsheetTypes: []
    }

    componentDidMount = () => {
        const cutsheetTypes = this.parseCutsheetTypes();
        this.setState({ cutsheetTypes });
    }

    /**
     * Get display name for cutsheet type
     */
    getCutsheetTypeDisplayName = (type) => {
        const displayNames = {
            [ConstantLightHouse.ISP_CUTSHEET_TYPE.LINE]: "Line Cutsheet",
            [ConstantLightHouse.ISP_CUTSHEET_TYPE.CLIENT]: "Client Cutsheet",
            [ConstantLightHouse.ISP_CUTSHEET_TYPE.INTERNAL_CABLING]: "Internal Cabling Cutsheet",
            [ConstantLightHouse.ISP_CUTSHEET_TYPE.BACKBONE_CLIENT_MIGRATION]: "Backbone Client Migration Cutsheet"
        };
        return displayNames[type] || type;
    }

    /**
     * Parse cutsheet types from URL parameters
     * Supports both 'cutsheetTypes' (comma-separated) and single 'cutsheetType' for backward compatibility
     */
    parseCutsheetTypes = () => {
        const cutsheetTypes = this.props.cutsheetType;

        if (cutsheetTypes) {
            // Parse comma-separated cutsheet types and deduplicate
            const types = cutsheetTypes.split(",")
                .map(t => t.trim())
                .filter(t => t)
                .reduce((unique, item) => (unique.includes(item) ? unique : [...unique, item]), []);
            return types;
        }

        // Default fallback
        return [ConstantLightHouse.ISP_CUTSHEET_TYPE.CLIENT];
    }

    render() {
        const { cutsheetTypes } = this.state;

        // If only one cutsheet type, render without the multi-dashboard wrapper
        if (cutsheetTypes.length === 1) {
            return (
                <IspDashboardV2
                    {...this.props}
                    cutsheetType={cutsheetTypes[0]}
                />
            );
        }

        // Render multiple dashboards
        return (
            <SpaceBetween direction="vertical" size="l">
                {cutsheetTypes.map((cutsheetType, index) => (
                    <Box key={cutsheetType} padding="s">
                        <IspDashboardV2
                            {...this.props}
                            cutsheetType={cutsheetType}
                            skipLighthouseHeader={index !== 0}
                            key={`${cutsheetType}`}
                        />
                    </Box>
                ))}
            </SpaceBetween>
        );
    }
}
